import { render, staticRenderFns } from "./PhoneDisplay.pug?vue&type=template&id=357c6070&scoped=true&lang=pug&"
import script from "./PhoneDisplay.vue?vue&type=script&lang=js&"
export * from "./PhoneDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PhoneDisplay.scss?vue&type=style&index=0&id=357c6070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357c6070",
  null
  
)

export default component.exports